/**
 * Interruttori della console.
 *
 * Non feature flag da database: sono decisioni di prodotto già prese, tenute
 * in un posto solo perché riaprirle sia una riga e non un archeologia.
 */

/**
 * Il link di approfondimento negli avvisi comunali.
 *
 * **Spento** dal 12/08/2026, decisione presa sull'app in `97e48bd`: nel box
 * d'emergenza il link era l'unica cosa che portava fuori, e chi legge
 * un'ordinanza di chiusura scuole non deve finire su un PDF del sito comunale
 * per sapere cosa fare. Il messaggio basta a sé stesso.
 *
 * Spento **qui** e non solo nell'app per una ragione precisa: se l'app non lo
 * mostra ma la console lo fa compilare, prima o poi un operatore scriverà
 * «tutti i dettagli al link» e nessuno lo vedrà mai. Un campo che accetta
 * qualcosa che non arriva a destinazione è peggio di un campo che non c'è.
 *
 * La **struttura resta**: `link_url` e `link_label` sono ancora colonne di
 * `comune_notices`, e `preview_comune_notice` / `publish_comune_notice` ne
 * accettano ancora i parametri — la console li manda `null`. Riaccenderlo
 * vuol dire mettere `true` qui e rimettere la riga nel box dell'app: nessuna
 * migration, nessun dato da recuperare.
 */
export const LINK_ENABLED = false;

/**
 * La notifica critica negli avvisi comunali.
 *
 * **Acceso** dal 04/09/2026, su richiesta esplicita: l'operatore può chiedere
 * che la push parta come *critical alert* di iOS — suona a volume pieno anche
 * con la suoneria spenta, con «Non disturbare» o una Full Immersion attiva.
 *
 * Va detto chiaro dove si legge il codice, non dove lo legge l'operatore: la
 * scelta arriva fino al dispatcher (`urgency = 'emergenza'` sulla riga e nel
 * payload del comando, vedi `lib/api.ts`), ma `am-backend` non la traduce
 * ancora in un interruption level né in un'entitlement Apple. La console
 * raccoglie la volontà del Comune e la conserva; la consegna «critica» vera è
 * il lavoro successivo. Se quel lavoro tardasse, mettere `false` qui toglie il
 * box senza toccare bozze, RPC o dati.
 */
export const CRITICAL_ALERT_ENABLED = true;
